/*
 * /about (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { DevEnableImage } from "@timeprox/core/dev"
import { AboutCard } from "@timeprox/react/components"
import { Image, Page } from "@timeprox/react/ui"
import { Built, Environment, SHA, Title, Version } from "@timeprox/utils/common"
import format from "date-fns/format"

export const Route = createFileRoute("/about")({ component: AboutPage })

function AboutPage() {
	return (
		<Page>
			<AboutCard
				title={"About"}
				subtitle={Title}
				details={[
					Environment,
					Version ? `v${Version}` : "Unknown Version",
					SHA,
					format(parseInt(Built, 10), "MMM d, h:mm a"),
				]}
			>
				<DevEnableImage>
					<Image
						src={"/assets/icons/transparent-192x192.png"}
						alt={"logo"}
						width={192}
						height={192}
					/>
				</DevEnableImage>
			</AboutCard>
		</Page>
	)
}
